import styled from "styled-components";

export const Container = styled.div`
    width: 350px;
    margin: 100px auto;
    
    text-align: center;
`;
